import { Route, Switch } from "wouter";

import About from "./About/About";
import Contact from "./Contact/Contact";
import Footer from "./Footer/Foot";
import Home from "./Home/HomeTree";
import Navbar from "./Nav/NavBar";
import ScrollToTop from "./ScrollToTop";
import Service from "./Service/Service";
import ServiceDetail from "./Service/ServiceDetail";

function App() {
  return (
    <>
      <Navbar />
 <ScrollToTop />
      <Switch>
        {/* Home */}
        <Route path="/" component={Home} />

        {/* Services list */}
        <Route path="/services" component={Service} />

        {/* Service details (dynamic route) */}
        <Route path="/services/:slug" component={ServiceDetail} />

        <Route path="/about" component={About} />
        <Route path="/contact" component={Contact} />

        {/* 404 fallback */}
        <Route>
          <div className="pt-32 text-center text-xl font-semibold">
            Page Not Found
          </div>
        </Route>
      </Switch>

      <Footer />
    </>
  );
}

export default App;
